import { Box, Divider, IconButton, Typography } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import zeplinColor from '../../../../../../theme/Color';
import { getAuthUrl } from '../../../../../../utilities/CalendarUtils';
import CustomButton from '../../../../../shared/CustomButton/CustomButton';
import { AccountRowItem } from './AccountRowItem';

type AccountRowProps = {
  name: string;
  accounts: {
    title: string;
    icon: string;
    type: string;
    value: string;
    color: string;
  }[];
  onSettingsClick: (
    e: MouseEvent<HTMLImageElement>,
    accountValue: {
      title: string;

      type: string;
      value: string;
    },
  ) => void;
};

export const AccountRow = ({ name, accounts, onSettingsClick }: AccountRowProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isConnected = name === 'Huddle' || accounts.length > 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 0',
          cursor: 'pointer',
        }}
      >
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <img
            src={name === 'Microsoft Teams' ? '/assets/microsoft-logo.svg' : `/assets/${name}.svg`}
            style={{ width: '20px' }}
            alt={name}
          />
          <Typography
            sx={{
              fontSize: { xs: '14px', xl: '16px' },
              color: zeplinColor.BasicBlack,
            }}
          >
            {name === 'Google Meet' ? 'Google Calendar' : name}
          </Typography>
        </Box>

        {!isConnected ? (
          <Link
            to={getAuthUrl(name)}
            style={{ textDecoration: 'none' }}
            onClick={() => {
              sessionStorage.setItem('calendar-provider', name);
              sessionStorage.setItem('calendar-connecting', 'true');
            }}
          >
            <CustomButton
              disabled={false}
              variant='outlined'
              color='customSecondary'
              style={{
                color: zeplinColor.BasicBlack,
                borderRadius: '8px',
                height: '32px',
                borderWidth: 1,
                borderColor: zeplinColor.BasicBlack,
                '&:hover': {
                  backgroundColor: zeplinColor.Neutral3,
                  color: zeplinColor.BasicBlack,
                },
                '&.MuiButton-root': {
                  padding: '6px 16px',
                },
              }}
              textStyle={{ fontSize: '14px' }}
              text={'Connect'}
              icon={''}
              onClick={(e: any) => {}}
            />
          </Link>
        ) : (
          <IconButton
            size='medium'
            onClick={() => setIsOpen((prev) => !prev)}
            sx={{ p: 0, ml: 0.5 }}
            aria-label='expand'
          >
            <img
              src={'/assets/down-arrow.svg'}
              style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: '0.2s',
                width: '24px',
              }}
              alt='down arrow'
            />
          </IconButton>
        )}
      </Box>

      {isOpen &&
        isConnected &&
        accounts.map((account) => (
          <AccountRowItem account={account} onSettingsClick={onSettingsClick} />
        ))}
      <Divider sx={{ borderColor: zeplinColor.Neutral5 }} />
    </Box>
  );
};
